import Summary from '@gameday/common/components/form/Pages/Summary'
import { uniqBy } from 'lodash'
import styled from 'styled-components'

import config from '../../../../constants/config'
import { common, files } from '../../../../constants/endpoints'
import { privateRoutes } from '../../../../constants/routes/routes'

const getAllFormProductsAndGroups = (products = [], subEvents = [], addOn = {}, productGroups = [], team = {}) => {
  let productList = []
  let productGroupList = []
  const filteredSEProducts = []
  const filteredSEProductGroups = []

  const { products: addOnProducts = [], productGroups: addOnProductGroups = [] } = addOn || {}
  const { products: teamProducts = [], productGroups: teamProductGroups = [] } = team || {}

  subEvents.forEach(s => {
    s.products.forEach(p => filteredSEProducts.push(p))
    s.productGroups.forEach(pg => filteredSEProductGroups.push(pg))
  })

  productList = [
    ...uniqBy(products, 'formProductId'),
    ...uniqBy(addOnProducts, 'formProductId'),
    ...uniqBy(filteredSEProducts, 'formProductId'),
    ...uniqBy(teamProducts, 'formProductId'),
  ]

  uniqBy(
    // biome-ignore lint/suspicious/noAssignInExpressions: TODO
    (productGroupList = [...productGroups, ...addOnProductGroups, ...filteredSEProductGroups, ...teamProductGroups]),
    'id'
  )

  const productsById = productList.reduce((a, r) => {
    // eslint-disable-next-line no-param-reassign
    a[r.sfid || r.id] = r
    return a
  }, {})

  return {
    products: productsById,
    productList,
    productGroupList,
  }
}

const StyledSummary = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
`

const SummaryComponent = ({
  organisation,
  formQuestions,
  registrations,
  user,
  userId,
  form,
  products,
  productGroups,
  removeMember,
  removeMemberItems,
  currentRegistration,
  setCurrentRegistration,
  validateSessions,
  submitRegistrations,
  setPaymentData,
  goto,
  next,
  setStartTimer,
  setSessionId,
  formType,
  paymentGateway,
  feeConfigurations,
  subEvents,
  addOn,
  discounts,
  isTeamEvent,
  teamFormType,
  team,
  registeredTeam,
  formSettings,
  displayPriceAsZero,
  resetInsurance,
  sessionId,
  ...rest
}) => {
  const paypal = paymentGateway.find(gateway => gateway.name.toLowerCase() === 'paypal')
  const braintree = paymentGateway.find(gateway => gateway.name.toLowerCase() === 'braintree')
  const orderedGateways = [braintree, paypal]
  const newOrdered = []
  orderedGateways.forEach(g => {
    g && newOrdered.push(g)
  })
  const remainingGateways = paymentGateway.filter(item => !newOrdered.includes(item))
  const paymentGateways = [...newOrdered, ...remainingGateways]

  return (
    <StyledSummary className="summary-page" formSettings={formSettings}>
      <Summary
        formData={{
          organisation,
          userId,
          form,
          // biome-ignore lint/complexity/useOptionalChain: TODO
          pageName: (privateRoutes(isTeamEvent).find(r => r.id === 'summary') || {}).title || 'Summary',
          application: config.application,
          registrations,
          ...getAllFormProductsAndGroups(products, subEvents, addOn, productGroups, team),
          discounts,
          formQuestions,
          subEvents,
          team,
          objectId: currentRegistration?.relatedMemberProfileId,
          objectName: 'memberProfile',
          uploadEndpoint: `api/${files.uploadDirect}`,
          downloadEndpoint: `api/${files.downloadDirect}`,
          subdivisionEndpoint: `api/${common.subdivision}?country={country}`,
          googleApiKey: config.GOOGLE_API_KEY,
          isTeamRego: isTeamEvent && teamFormType === 'Register A Team',
          isTeamEvent,
          registeredTeam,
        }}
        removeMember={removeMember}
        removeMemberItems={removeMemberItems}
        goto={goto}
        next={next}
        setCurrentRegistration={setCurrentRegistration}
        validateSessions={validateSessions}
        submitRegistrations={submitRegistrations}
        setPaymentData={setPaymentData}
        formType={formType}
        paymentGateway={paymentGateways}
        setStartTimer={setStartTimer}
        reset={() => {
          setStartTimer(false)
          setSessionId(null)
          goto(-1)
        }}
        feeConfigurations={feeConfigurations}
        displayPriceAsZero={displayPriceAsZero}
        isTeamEvent={isTeamEvent}
        teamFormType={teamFormType}
        formSettings={formSettings}
        sessionId={sessionId}
        onRegisterAnother={() => {
          resetInsurance()
          goto(isTeamEvent ? (teamFormType === 'Register A Team' ? 0 : 1) : -1)
        }}
        {...rest}
      />
    </StyledSummary>
  )
}

export default SummaryComponent
